module.exports = __webpack_public_path__ + "static/media/lol-masters.6ec8c1e8.png";